export default __webpack_public_path__ + "30fa601bb63c0adcf2502c5a64e322f5.png";